export const HOME = '/';
export const ABOUT_ME = '/about'
export const ARTICLES = '/post'
export const PROJECTS = '/projects'